import Image from "next/image";
import React from "react";

export default function OfficeMobile({ locations, selectedOffice }: any) {
    const currentOffice = locations.find((location: any) => {
        return location.country === selectedOffice;
    });

    // split the address based on \n
    const address = currentOffice.locationDetails.address.split("\n");

    return (
        <div
            className={`relative min-h-[240px] flex flex-col px-8 md:px-6 py-8 md:py-4 space-y-4 justify-start md:justify-center`}
        >
            <div className={`font-semibold text-md md:text-lg text-white`}>
                {/* {currentOffice.locationDetails.address} */}
                {/* render the address array */}
                {address.map((line: string, index: number) => (
                    <div key={index} className="mb-0">
                        {line}
                    </div>
                ))}
            </div>
            <div className="">
                {currentOffice.locationDetails.contactNumber && (
                    <div className="flex items-center gap-2">
                        <Image
                            src="/mobile.svg"
                            alt="mobile icon"
                            width={20}
                            height={20}
                        />
                        <a
                            href={`tel:${
                                currentOffice.locationDetails.contactNumber.split(
                                    "/"
                                )[0]
                            }`}
                            className={`phone-num mb-0 text-md font-medium text-white`}
                        >
                            {currentOffice.locationDetails.contactNumber}
                        </a>
                    </div>
                )}
                {currentOffice.locationDetails.faxNumber && (
                    <div className="flex items-center gap-2">
                        <Image
                            src="/printer.svg"
                            alt="mobile icon"
                            width={20}
                            height={20}
                        />
                        <span className={`mb-0 text-md font-medium text-white`}>
                            {currentOffice.locationDetails.faxNumber}
                        </span>
                    </div>
                )}
                <div className="flex items-center gap-2">
                    <Image
                        src="/mail.svg"
                        alt="mobile icon"
                        width={20}
                        height={20}
                    />
                    <a
                        href={`mailto:${currentOffice.locationDetails.email}`}
                        className={`email-address mb-0 text-md font-medium text-white`}
                    >
                        {currentOffice.locationDetails.email}
                    </a>
                </div>
            </div>
        </div>
    );
}
